// extracted by mini-css-extract-plugin
export default {"productGrid":"q1-z","centerLink":"r1-z","productSection":"s1-z","item":"t1-z","ctaButton":"u1-z"};